import "./EditMemberModal.css";
import { useState } from "react";

export default function EditMemberModal({ member, onSave, onClose }) {
  const [name, setName] = useState(member.name || "");

  function handleSubmit(e) {
    e.preventDefault();
    onSave({ ...member, name });
  }

  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h2>Edit Member</h2>

        <form onSubmit={handleSubmit}>
          <label>Name:</label>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <div className="modal-buttons">
            <button type="submit">Save</button>
            <button
              type="button"
              onClick={onClose}
              className="cancel-btn"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
